import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "./ui/accordion";

const items = [
    {
        q: "Hvornår launcher Cleany?",
        a: "Vi launcher offentligt den 1. oktober 2026. Tilmeld dig ventelisten og bliv inviteret tidligt.",
    },
    {
        q: "Hvad koster Cleany?",
        a: "Cleany Core koster 1.495 kr/md og inkluderer 1 administrator og 20 medarbejder-brugere. Du tilkøber kun de moduler du har brug for — se prisstrukturen ovenfor for de præcise tal. Alle priser er ekskl. moms.",
    },
    {
        q: "Kan vi prøve Cleany gratis?",
        a: "Ja. Alle nye kunder får 14 dages gratis prøveperiode med fuld adgang til Cleany Core og de tillægsmoduler I vælger. Ingen kreditkort ved tilmelding, og prøveperioden overgår først til betalt abonnement når I aktivt bekræfter det. Prøveperioden starter når I får jeres onboarding og adgang efter launch 1. oktober 2026.",
    },
    {
        q: "Integrerer Cleany med vores økonomisystem?",
        a: "Ja — vi understøtter e-conomic og Dinero ved launch. Microsoft Dynamics 365 Business Central og Billy er på roadmap. Et offentligt API kommer kort efter launch.",
    },
    {
        q: "Hvor opbevares vores data?",
        a: "Alt data hostes hos europæiske cloud-udbydere og er fuldt GDPR-compliant. Vi krypterer både i transit og at rest.",
    },
    {
        q: "Kan vi bruge Cleany ude i felten?",
        a: "Ja. Cleany er bygget mobil-first så jeres medarbejdere opgaver, besøg og kvalitet direkte fra telefonen — også offline.",
    },
    {
        q: "Hvor lang er onboardingen?",
        a: "De fleste firmaer er live på 3–5 dage. Vi hjælper med opsætning af anlægsarkiv, nøgledatabase og medarbejdere som en del af onboardingen.",
    },
    {
        q: "Kan vi opsige når vi vil?",
        a: "Ja. Cleany er måned-til-måned, ingen binding. Eksport af jeres data er altid gratis.",
    },
];

export default function FAQ() {
    return (
        <section id="faq" className="py-24 md:py-32 bg-slate-50/60 border-y border-slate-200/70" data-testid="faq-section">
            <div className="max-w-4xl mx-auto px-6 lg:px-10">
                <div className="max-w-2xl">
                    <div className="inline-flex items-center gap-2 rounded-full bg-white border border-slate-200 px-3 py-1 text-xs font-semibold text-slate-700">
                        <span className="h-1.5 w-1.5 rounded-full bg-sky-500" /> FAQ
                    </div>
                    <h2 className="mt-5 font-display text-3xl md:text-5xl font-bold tracking-tight text-slate-900">
                        Spørgsmål vi ofte får.
                    </h2>
                </div>
                <div className="mt-12 rounded-2xl bg-white border border-slate-200 p-2">
                    <Accordion type="single" collapsible className="w-full">
                        {items.map((it, i) => (
                            <AccordionItem
                                key={i}
                                value={`item-${i}`}
                                className="px-4 border-slate-200"
                                data-testid={`faq-item-${i}`}
                            >
                                <AccordionTrigger className="text-left text-base font-display font-semibold text-slate-900 hover:no-underline py-5">
                                    {it.q}
                                </AccordionTrigger>
                                <AccordionContent className="text-slate-600 leading-relaxed text-[15px]">
                                    {it.a}
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>
                </div>
            </div>
        </section>
    );
}
